import { useEffect, useMemo, useRef, useState } from "react";
import moment from "jalali-moment";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import { IPath } from "Types/path";
import useCameras from "Hooks/useCamera";
import { selectCamera } from "Redux/cameraSlice";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";
import { changeSelectedZones, changeSelectedSubZones, clearSelectedZones } from "Redux/marginParkSlice";
import ClearIcon from "@mui/icons-material/Clear";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function MarginPark() {
  const dispatch = useAppDispatch();
  const { visible, selectedZones, selectedSubZones } = useAppSelector((state) => state.marginPark);

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [cameraName, setCameraName] = useState<string>("");

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const { data } = useCameras();

  const allData = [
    { id: "1", subZones: [] },
    { id: "2", subZones: [] },
    { id: "2", subZones: [] },
    { id: "4", subZones: [] },
    { id: "5", subZones: [] },
    { id: "6", subZones: ["پارک لاله", "بيمارستان امام خميني"] },
    { id: "7", subZones: [] },
    { id: "8", subZones: [] },
    { id: "9", subZones: [] },
    { id: "10", subZones: [] },
    { id: "11", subZones: [] },
    { id: "12", subZones: [] },
    { id: "13", subZones: [] },
    { id: "14", subZones: [] },
    { id: "15", subZones: [] },
    { id: "16", subZones: [] },
    { id: "17", subZones: [] },
    { id: "18", subZones: [] },
    { id: "19", subZones: [] },
    { id: "20", subZones: [] },
    { id: "21", subZones: [] },
    { id: "22", subZones: [] },
  ];

  const handleClickZones = (item: any) => {
    dispatch(changeSelectedZones(item));
  };

  const handleClickSubZones = (item: any) => {
    let newSelected;

    if (selectedSubZones.includes(item)) {
      newSelected = selectedSubZones.filter((c) => c !== item);
    } else {
      newSelected = [...selectedSubZones, item];
    }
    dispatch(changeSelectedSubZones(newSelected));
    const subZoneParam = newSelected.map((s) => {
      return { $type: "WebParameterValue", Id: s, Value: s };
    });
    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=558b06a0-6092-44e0-ba4d-3d2e8686ed76&paramvalues={"6d698887-fe24-9be0-f1db-26d5226fb95f":[{"Value":${JSON.stringify(
          subZoneParam
        )},"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=ba043ce2-7628-4e8f-acfa-81add55910a0&paramvalues={"6d698887-fe24-9be0-f1db-26d5226fb95f":[{"Value":${JSON.stringify(
          subZoneParam
        )},"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };

  const renderAllZones = useMemo(() => {
    return (
      <>
        {allData?.map((item: any) => {
          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "90%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                  // backgroundColor: camera?.DeviceCode === selectedCamera[0]?.DeviceCode ? "red" : "",
                }}
                onClick={() => handleClickZones(item)}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {item.id} منطقه
                  </Grid>
                </Stack>
              </Button>
              <Checkbox
                inputProps={{ "aria-label": "Checkbox demo" }}
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                }}
              />
            </Stack>
          );
        })}
      </>
    );
  }, [data, cameraName]);

  const renderSubZones = useMemo(() => {
    if (selectedZones.length === 0) return;

    const subZones: any[] = selectedZones[0]?.subZones;

    console.log(selectedSubZones, "bhnergbgbh");

    return (
      <>
        {subZones?.map((item: any) => {
          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "90%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                  backgroundColor: selectedSubZones.includes(item) ? "rgb(0 160 128 / 20%)" : "",
                }}
                onClick={() => handleClickSubZones(item)}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {item}
                  </Grid>
                </Stack>
                {selectedSubZones.includes(item) ? <ClearIcon sx={{ color: "red" }} /> : null}
              </Button>
              <Checkbox
                inputProps={{ "aria-label": "Checkbox demo" }}
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                }}
              />
            </Stack>
          );
        })}
      </>
    );
  }, [selectedZones, selectedSubZones]);

  return (
    <Fade in={visible} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">لیست لوپ ها </Typography>
          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Grid container justifyContent="space-around" alignItems="center" sx={{ boxSizing: "border-box" }}>
            <Grid item xs={selectedZones.length > 0 ? 10.5 : 12}>
              <TextField
                id="camera-search"
                label="جستجو"
                variant="outlined"
                sx={{ width: selectedZones.length > 0 ? "100%" : "87%" }}
                value={cameraName}
                onChange={(e) => setCameraName(e.target.value)}
              />
            </Grid>
            {selectedZones.length > 0 ? (
              <Grid item xs={1.5}>
                <Button onClick={() => dispatch(clearSelectedZones())}>
                  <ArrowBackIcon />
                </Button>
              </Grid>
            ) : null}
          </Grid>

          <Box sx={{ height: boxHeight, py: 2, overflowY: "scroll" }} ref={sideRef}>
            {selectedZones.length > 0 ? renderSubZones : renderAllZones}
          </Box>
        </Collapse>
      </Card>
    </Fade>
  );
}
